import type { ReactNode } from "react";
import { cx } from "./cx";

export interface PopoverProps {
  /** Controlled visibility — owners manage open state (no portal, no JS positioning). */
  open: boolean;
  /** The anchor element the panel positions against. */
  trigger: ReactNode;
  align?: "start" | "end";
  children: ReactNode;
  className?: string;
}

export function Popover({ open, trigger, align = "start", children, className }: PopoverProps) {
  return (
    <span className="pz-popover-anchor">
      {trigger}
      {open && (
        <div className={cx("pz-popover", align === "end" && "pz-popover--align-end", className)} role="dialog">
          {children}
        </div>
      )}
    </span>
  );
}
